import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LanguageSelectionModule } from '../language-selection/language-selection.module';
import { LinkTvModule } from '../link-tv/link-tv.module';
import { MyAhaModule } from '../my-aha/my-aha.module';
import { SearchPageModule } from '../search-page/search-page.module';
import { SharedComponentsModule } from '../shared/shared-components/shared.components.module';
import { ShimmerModule } from '../shimmer/shimmer.module';
import { StorefrontHttpService } from './storefront-http.service';
import { StorefrontRoutingModule } from './storefront-routing.module';
import { StorefrontComponent } from './storefront/storefront.component';
import { TvVerticalMenuComponent } from './tv-vertical-menu/tv-vertical-menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { ItemPositionClassPipe } from './storefront/hero-carousel-pipe/item-position-class.pipe';
import { CollectionStorefrontComponent } from './collection-storefront/collection-storefront.component';

@NgModule({
  declarations: [
    TvVerticalMenuComponent,
    StorefrontComponent,
    ItemPositionClassPipe,
    CollectionStorefrontComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    StorefrontRoutingModule,
    SharedComponentsModule,
    MyAhaModule,
    LinkTvModule,
    LanguageSelectionModule,
    SearchPageModule,
    ShimmerModule,
    TranslateModule,
  ],
  providers: [StorefrontHttpService],
  exports: [
    TvVerticalMenuComponent,
    CollectionStorefrontComponent,
    StorefrontRoutingModule,
    StorefrontComponent,
    ItemPositionClassPipe,
  ],
})
export class StorefrontModule {}
